import {
  Autocomplete,
  Box,
  TextField,
  createFilterOptions
} from '@mui/material';
import { CURRENCIES, CURRENCY_LOCALES } from '../../../common/currencyFormat';
import { formatNumberValue } from '../../../common/numberFormat';

const localeNames = new Intl.DisplayNames(['en'], { type: 'language' });
const filterLocales = createFilterOptions({
  stringify: (locale) => locale + ' ' + localeNames.of(locale)
});

const CurrencyConfiguration = ({ config, onChange }) => {
  const change = (name, value) => onChange({ target: { name, value } });
  const previewConfig = {
    ...config,
    decimal_places:
      config.decimal_places === '' || config.decimal_places === undefined
        ? undefined
        : Number(config.decimal_places)
  };
  return (
    <>
      <Autocomplete
        options={CURRENCIES}
        value={CURRENCIES.find(({ code }) => code === config.currency) || null}
        getOptionLabel={({ code, name }) => code + ' — ' + name}
        isOptionEqualToValue={(option, value) => option.code === value.code}
        onChange={(_, currency) => change('currency', currency?.code || '')}
        renderInput={(params) => (
          <TextField {...params} margin="dense" label="Currency" />
        )}
      />
      <Autocomplete
        freeSolo
        options={CURRENCY_LOCALES}
        filterOptions={filterLocales}
        inputValue={config.locale || ''}
        onInputChange={(_, value) => change('locale', value)}
        renderOption={({ key, ...props }, option) => (
          <li key={key} {...props}>
            {localeNames.of(option)} ({option})
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            margin="dense"
            label="Display Locale"
            helperText="Choose a regional format or enter another locale, such as fr-CA."
          />
        )}
      />
      <Box mt={1}>
        Preview: <bdi>{formatNumberValue(1234.56, previewConfig)}</bdi>
      </Box>
      <Box mt={1}>
        Changing currency relabels existing values without converting amounts.
      </Box>
    </>
  );
};

export default CurrencyConfiguration;
